import HundredBricksAPIError from '../../HundredBricksAPIError';
class CannotRegisterJobTitle extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('CannotRegisterJobTitle', ...args);
    }
}
export default CannotRegisterJobTitle;
